import roomService from '@/api/room'
import { ROOM_SET, ROOM_BEHAVIOR_SET, COMBINED_ROOM_BEHAVIOR_SET, ROOM_NAME, ROOM_DEVICES, ROOM_DEVICES_BLOCK_ACCESS_SET} from '../types'
import utils from '@/utils/utils.js'

export default {
  namespaced: true,
  state: {
    rooms: [],
    behavior: {},
    combinedRoomBehavior: {},
    roomName: '',
    devicesIds: [],
    blockAccessUponPriorRoomBooking: false
  },
  getters: {
    behaviorStore: (state) => {
      return state.behavior
    },
    combinedRoomBehaviorStore: (state) => {
      return state.combinedRoomBehavior
    },
    roomsQtd (state) {
      return state.rooms.filter(room => room.active && !room.isCombinedRoom).length
    },
    hasQuota (state, getters, rootState) {
      return rootState.Global.initialSettings.rooms.roomsQuota > getters.roomsQtd
    },
    combinedRoomsQtd (state) {
      return state.rooms.filter(room => room.active && room.isCombinedRoom).length
    },
    hasCombinedRoomsQuota (state, getters, rootState) {
      return rootState.Global.initialSettings.rooms.combinedRoomsQuota > getters.combinedRoomsQtd
    }
  },
  mutations: {
    [ROOM_SET] (state, rooms) {
      state.rooms = rooms
    },
    [ROOM_BEHAVIOR_SET] (state, behavior) {
      state.behavior = behavior
    },
    [COMBINED_ROOM_BEHAVIOR_SET] (state, behavior) {
      state.combinedRoomBehavior = behavior
    },
    [ROOM_NAME] (state, roomName) {
      state.roomName = roomName
    },
    [ROOM_DEVICES] (state, devicesIds) {
      state.devicesIds = devicesIds
    },
    [ROOM_DEVICES_BLOCK_ACCESS_SET] (state, blockAccessUponPriorRoomBooking) {
      state.blockAccessUponPriorRoomBooking = blockAccessUponPriorRoomBooking
    }
  },
  actions: {
    getRoomsList: function ({commit, dispatch, rootState}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        roomService.getRooms().then((response) => {
          let _rooms = response.data
          dispatch('Location/getLocationsList', {}, {root: true}).then(() => {
            _rooms.forEach((room) => {
              rootState.Location.locations.forEach((location) => {
                if (room.locationId === location.id) {
                  room.locationName = location.locationName
                }
              })
            })
            commit(ROOM_SET, _rooms)
            dispatch('Global/hideLoading', null, {root: true})
            resolve()
          })
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    createRoom: function ({}, obj) {
      return new Promise((resolve, reject) => {
        roomService.createRoom(obj.locationId, obj.room).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    createCombinedRoom: function ({}, obj) {
      return new Promise((resolve, reject) => {
        roomService.createCombinedRoom(obj.locationId, obj.room).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    editRoom: function ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        roomService.editRoom(obj.locationId, obj.room).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    editCombinedRoom: function ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        roomService.editCombinedRoom(obj.locationId, obj.room).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    deleteRoom: function ({ dispatch }, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        roomService.deleteRoom(obj.locationId, obj.roomId).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    sendRoomImage: function ({}, obj) {
      return new Promise((resolve, reject) => {
        roomService.sendRoomImage(obj.roomId, obj.image).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getBehaviorList: function ({commit}, obj) {
      return new Promise((resolve, reject) => {
        roomService.getBehavior(obj.roomId).then((response) => {
          commit(ROOM_BEHAVIOR_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getCombinedRoomBehavior: function ({commit}, obj) {
      return new Promise((resolve, reject) => {
        roomService.getCombinedRoomBehavior(obj.roomId).then((response) => {
          commit(COMBINED_ROOM_BEHAVIOR_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    saveBehavior: function ({}, obj) {
      return new Promise((resolve, reject) => {
        roomService.saveBehavior(obj.locationId, obj.roomId, obj.behavior).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    saveCombinedRoomBehavior: function ({}, obj) {
      return new Promise((resolve, reject) => {
        roomService.saveCombinedRoomBehavior(obj.locationId, obj.roomId, obj.combinedRoomBehavior).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    toggleActive: function ({dispatch}, obj) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        roomService.toggleActive(obj.locationId, obj.roomId, obj.active).then(() => {
          dispatch('getRoomsList').then(() => {
            resolve()
          })
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    checkCalendarConnection: function ({}, roomEmail) {
      return roomService.checkCalendarConnection(roomEmail)
    },
    // eslint-disable-next-line no-empty-pattern
    getImage: function ({}, roomId) {
      return new Promise(resolve => {
        return roomService.getImage(roomId).then((response) => {
          resolve(utils.getImageFromApi(response))
        })
      })
    },
    getRoomName: function ({commit, state}, id) {
      commit('ROOM_NAME', state.rooms.filter(room => room.id === id)[0].name)
    },
    async getRoomDevices ({commit, dispatch}, roomId) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let response = await roomService.getRoomDevices(roomId)
        commit(ROOM_DEVICES, response.data.devices ?? [])
        commit(ROOM_DEVICES_BLOCK_ACCESS_SET, response.data.blockAccessUponPriorBooking)
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveRoomDevices ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        await roomService.saveRoomDevices(payload.workPlaceId, payload.devicesIds, payload.blockAccessUponPriorBooking)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
  }
}
